import React, { useState } from 'react';
import './ForgotPassword.css';
import '../Authentication.css';
import { REGISTER_PATH } from '../../../constants';
import { FIREBASE_AUTH } from '../../../FirebaseConfig';
import { sendPasswordResetEmail } from 'firebase/auth';
import InputField from '../InputField';

const ForgotPassword = () => {
    const [theEmail, setTheEmail]= useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const auth = FIREBASE_AUTH;
    
    const sendEmail = async (e) => {
        e.preventDefault();
        setLoading(true);
        setSent(false);
        try {
            await sendPasswordResetEmail(auth, theEmail);
            setSent(true);
        } catch (error) {
            alert("Firebase failure: " + error.message)
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className='auth-main-container'>
            {!sent ? 
                <div className='auth-white-box'>
                    <h1>FORGOT PASSWORD</h1>

                    <div className='forgot-password-text'>
                        <p>If you do not have an account, <a href={REGISTER_PATH} className="auth-link">click here </a> to set up a new account. </p>
                        <p>Type the email address associated with your account in the field below to recieve a validation code by email.</p>
                    </div>


                    <form className='auth-form' onSubmit={sendEmail}>
                        <InputField
                            label="EMAIL ADDRESS"
                            name="email"
                            value={theEmail}
                            type="email"
                            placeholder="fakeEmail@gatech.edu"
                            onChange={setTheEmail}
                        />

                        <input
                            className="auth-button"
                            type="submit"
                            value="SEND EMAIL"
                            disabled={loading}
                        />
                    </form>
                </div> :

                <div className='auth-white-box'>
                    <p>Please check your {theEmail} inbox for a link to reset your password.</p>
                </div>
            }
        </div>
    )
}

export default ForgotPassword